import * as React from 'react';
import { Text } from '@react-pdf/renderer';
import { parsePdfSub2 } from '../generisch/helper';

interface WpdfTextProps extends React.ClassAttributes<any> {
    pdf?: boolean;
    style?: React.CSSProperties | any;
    onClick?: () => void;
    tooltip?: string;
    getPageNum?: (pageNumber: number) => void;
}
export class WpdfText extends
    React.Component<WpdfTextProps, {}> {

    constructor(props: any) {
        super(props);
    }

    render() {
        if (this.props.pdf) {
            return <Text
                style={this.props.style}
            >
                {parsePdfSub2(this.props.children, this.props.style)}
                {typeof this.props.getPageNum === 'function' && <Text
                    fixed
                    render={({ pageNumber, totalPages }) => {
                        this.props.getPageNum(pageNumber);
                        return null;
                    }}
                />}
            </Text>;
        } else {
            return <div
                style={this.props.style}
                onClick={this.props.onClick}
                title={this.props.tooltip}
            >
                {this.props.children}
            </div>;
        }
    }
}
